import React, { forwardRef, ReactNode, TextareaHTMLAttributes } from 'react';
import cn from 'classnames';

export interface TextAreaProps
    extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    id: string;
    /**
     * Whether or not the text area has a dynamic height
     */
    dynamicHeight?: boolean;
    /**
     * Label inside the text area, can also contain React elements
     */
    label?: ReactNode;
}

/**
 * Representation of text area
 */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (props, ref) => {
        const { id, dynamicHeight, label, className, style, ...rest } = props;
        const classes = cn(
            'a-text-area',
            { [`a-text-area--dynamic-height`]: dynamicHeight },
            className,
        );

        return (
            <div className={classes} style={style}>
                {label && <label htmlFor={id}>{label}</label>}
                <textarea id={id} ref={ref} {...rest} />
                {dynamicHeight && <div className="a-text-area__shadow" />}
            </div>
        );
    },
);
TextArea.displayName = 'TextArea';
